import { ApplicationConfig, provideAppInitializer } from '@angular/core';
import { provideRouter, withRouterConfig, RouteReuseStrategy } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { App_Route } from './app.routes';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading-interceptor';
import { ReloadRouteReuseStrategy } from './core/strategies/reload-route-reuse.strategy';
import { MasterPreset } from './core/config/theme.config';
import { disableBrowserAutofill } from './core/helpers/disable-browser-autofill';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(App_Route, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    { provide: RouteReuseStrategy, useClass: ReloadRouteReuseStrategy },
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor,loadingInterceptor])),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    // App-wide date format: every p-datepicker displays DD-MM-YYYY unless it overrides dateFormat.
    // The Aura theme with the product's colours; dark mode follows the `dark` class the app state puts on <html>.
    providePrimeNG({
      overlayAppendTo: 'body',
      theme: { preset: MasterPreset, options: { darkModeSelector: '.dark' } },
      translation: { dateFormat: 'dd-mm-yy' },
    }),
    provideAppInitializer(() => {
      disableBrowserAutofill();
    }),
    MessageService,
  ],
};



